import { FormHelperText, RadioGroup } from '@mui/material';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import styled from 'styled-components';

const StyledLabel = styled.span`
  color: ${({ isActive }) => (isActive ? '#753CBE' : '#7B7B7B')};
  font-family: dana;
  font-size: 14px;
  margin-right: 17px;
  font-weight: 700;
`;
const RadioBtn = (
    <Radio
        sx={{
            color: 'rgba(172, 172, 172, 0.5)',
            border: '1px solid red',
            '& .MuiSvgIcon-root': {
                border: '1px solid #ACACAC',
                fontSize: '0px',
            },
            '&:hover': {
                backgroundColor: 'none',
            },
        }}
    />
);

function PregnancyRadio(props) {
    const { name, items, errors, values, label, handleChange, show } = props;
    const pregnancy = values[name] ?? false
    return (
        <div>
            <p style={{ color: '#707070', marginBottom: '20px',marginTop:'18px' }}>{label} :</p>
            <Grid container>
                <RadioGroup
                    row
                    name={name}
                    disableRipple
                    value={values[name]}
                    sx={{ width: '100%' }}
                    onChange={handleChange}
                >
                    {items?.map((item, index) => (
                        <Grid item xs={6}>
                            <Radio
                                sx={{ width: '0' }}
                                key={index}
                                value={item?.value}
                                label={item?.label}
                                control={RadioBtn}
                                checked={JSON.parse(pregnancy) === item?.value}
                            />
                            <StyledLabel isActive={JSON.parse(pregnancy) === item?.value}>
                                {item?.label}
                            </StyledLabel>
                        </Grid>
                    ))}
                    <span style={{fontSize:'12px', marginTop: '30px', color: '#4E4E4E' }}>
             بعد از  اتمام بارداری فرد حتما گزینه بارداری را غیرفعال کنید تا گزارشات در ناحیه معمولی نشان داده شود.
          </span>
                </RadioGroup>
                {errors[name] && <FormHelperText>{errors[name]}</FormHelperText>}
            </Grid>
        </div>
    );
}

export default PregnancyRadio;